import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import { useDevice } from 'seagull';
import styles from './InitialsAvatar.module.scss';
export const InitialsAvatar = (_0)=>{
    let { userInitials, isActive } = _0, rest = _object_without_properties(_0, [
        "userInitials",
        "isActive"
    ]);
    const { isMobileDevice } = useDevice();
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({}, rest), {
        className: cn(styles.avatar, {
            [styles.isActive]: isActive,
            [styles.mobile]: isMobileDevice
        }),
        children: /*#__PURE__*/ _jsx("span", {
            children: userInitials
        })
    }));
};
